/**
 * localStorage keys that belong to the *current identity and org*, beyond the
 * `dashboard:workspaceId` / `dashboard:workspaceName` pair that
 * `@airclou/auth-react` clears on its own.
 *
 * One list, two readers — the shared provider and `ActivityTracker`'s renewal.
 * Renewing now derives from the session cookie, so it can land on a different
 * user or org; the two paths have to clear the same set or the one that runs
 * leaves the other's keys behind.
 *
 * See apps/auth/docs/session-credential-standardization-plan.md (ID-1, ID-8).
 */
export const DASHBOARD_SCOPE_KEYS = ['dashboard:companyId'];
